import { useMemo } from "react";
import { FilterGroup } from "../types";

export const useSearchFilterGroups = (
  filterText: string,
  filterGroups: FilterGroup[] | null,
): FilterGroup[] | null => {
  const filteredFilters = useMemo(() => {
    if (filterGroups === null) return null;
    return filterText === ""
      ? filterGroups
      : filterGroups
          .map((group) => ({
            ...group,
            filters: group["filters"].filter((item) =>
              item.label.toLowerCase().includes(filterText.toLowerCase()),
            ),
          }))
          .filter((group) => group.filters.length > 0);
  }, [filterText, filterGroups]);
  return filteredFilters;
};
